import React, { FC } from 'react';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';

export const ConditionalTooltip: FC<{ enabled: boolean } & TooltipProps> = ({ enabled, children, ...props }) => {
  if (enabled) {
    return <Tooltip {...props}>{children}</Tooltip>;
  } else return children;
};
